import { LanguageContext } from './LanguageContext';
import { useContext } from 'react';

function Header() {
    const { language, setLanguage, textContent } = useContext(LanguageContext);
    
    const handleSectionClick = (section, e) => {
        // allow default anchor navigation but update title; hashchange tracking will send GA
        try {
            const labels = {
              th: {
                hero: 'หน้าแรก',
                about: textContent.aboutTitle,
                services: textContent.servicesTitle,
                contact: textContent.contactTitle,
              },
              en: {
                hero: 'Home',
                about: textContent.aboutTitle,
                services: textContent.servicesTitle,
                contact: textContent.contactTitle,
              },
            };
            const title = `${textContent.companyName} | ${labels[language][section]}`;
            document.title = title;
        } catch (err) {
            // ignore
        }
    };

    return (
        <header className="sticky top-0 z-50">
            {/* Top part of the header */}
            <div className="bg-blue-900 text-white py-2">
                <div className="container mx-auto flex justify-between items-center px-4 max-w-none w-full">
                    <h1 className="text-xl font-bold"><a href='/'>{textContent.header}</a></h1>
                    <div className="flex space-x-2">
                        <button
                            onClick={() => setLanguage('th')}
                            className={`px-4 py-1 rounded-lg ${language === 'th' ? 'bg-white text-blue-900' : 'bg-blue-900 text-white'}`}
                        >
                            TH
                        </button>
                        <button
                            onClick={() => setLanguage('en')}
                            className={`px-4 py-1 rounded-lg ${language === 'en' ? 'bg-white text-blue-900' : 'bg-blue-900 text-white'}`}
                        >
                            EN
                        </button>
                    </div>
                </div>
            </div>

            {/* Bottom part of the header */}
            <div className="bg-white py-4 shadow-md">
                <div className="container mx-auto flex justify-between items-center px-4 max-w-none w-full">
                    {/* Logo Section */}
                    <div className="flex items-center space-x-2">
                        <a href="/"><img src="/logo.png" alt="AI Business Technology Co., Ltd." className="h-10 w-auto" /></a>                        
                    </div>

                    {/* Navigation Menu */}
                    <nav className="hidden md:block">
                        <ul className="flex space-x-4">
                            <li>
                                <a href="/#hero" className="hover:underline text-blue-900" onClick={(e) => handleSectionClick('hero', e)}>
                                    {language === 'th' ? 'หน้าแรก' : 'Home'}
                                </a>
                            </li>
                            <li>
                                <a href="/#about" className="hover:underline text-blue-900" onClick={(e) => handleSectionClick('about', e)}>
                                    {language === 'th' ? 'เกี่ยวกับเรา' : 'About'}
                                </a>
                            </li>
                            <li>
                                <a href="/#services" className="hover:underline text-blue-900" onClick={(e) => handleSectionClick('services', e)}>
                                    {language === 'th' ? 'บริการ' : 'Services'}
                                </a>
                            </li>
                            <li>
                                <a href="/#contact" className="hover:underline text-blue-900" onClick={(e) => handleSectionClick('contact', e)}>
                                    {language === 'th' ? 'ติดต่อเรา' : 'Contact'}
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </header>
    );
}

export default Header;
